export default __webpack_public_path__ + "static/Entenda0066-504b38497a3358be6af848a758536866.jpg";